import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import { Helmet } from 'react-helmet';
import { WidgetMapaAvisos } from '../../widgets/MapaAvisos/WidgetMapaAvisos';
import API from '../../utils/api';
import { translate } from '../../utils/translations';
import {
    buildLanguageConfig,
    consoleLogError,
    formatDateUi,
} from '../../utils/utils';
import { parse } from 'qs';
import { WIDGETS_PADDING } from '../../utils/globals';

export class MapaAvisos extends PureComponent {
    state = {
        config: buildLanguageConfig({}),
        data: [],
        widgetDate: '',
    };

    render() {
        const { preview } = this.props;
        const { config, data, widgetDate } = this.state;
        const { language } = config;

        return (
            <div className="MapaAvisos" style={WIDGETS_PADDING}>
                <Helmet>
                    <title>
                        {preview
                            ? translate(language, 'config_title')
                            : translate(language, 'avisos_title')}
                    </title>
                </Helmet>
                <WidgetMapaAvisos
                    data={data}
                    config={config}
                    preview={preview}
                    widgetDate={widgetDate}
                />
            </div>
        );
    }

    componentDidMount() {
        this.feedWidget();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.feedWidget();
        }
    }

    feedWidget = async () => {
        const { location, preview, color, language } = this.props;
        const search = location ? location.search : '';

        let config = {};

        // From Configurador form
        if (preview === true) {
            config = {
                color,
                language,
                target: this.props.target,
            };
        } else {
            // Or from Query String
            let querySearch = search
                .split('"')[0]
                .split('%22')[0]
                .split('%20')[0];
            config = buildLanguageConfig(
                parse(querySearch, {
                    ignoreQueryPrefix: true,
                })
            );
        }

        const widgetDate = formatDateUi(new Date());
        this.setState({ config, widgetDate });
        this.cancelTokenSource = CancelToken.source();

        try {
            let data = await API.getAvisos(this.cancelTokenSource.token);
            this.setState({ data: data.map(el => el.data) });
        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }
    };

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.state.config.language, 'cancelled_request')
        );
    }
}

export default MapaAvisos;



// WEBPACK FOOTER //
// ./src/containers/MapaAvisos/MapaAvisos.js